import script from "./DashboardSettingsDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSettingsDrawer.vue?vue&type=style&index=0&id=420aedf6&lang=scss"

const __exports__ = script;

export default __exports__